import { makeStyles } from 'tss-react/mui';

const useStylesList: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  list: {
    padding: '0 !important',
    width: '100%',
  },
  listOffset: {
    paddingTop: '8px !important',
    paddingBottom: '8px !important',
  },
  listLoading: {
    marginBottom: 75,
  },
}));

export default useStylesList;
